export const QuizActionEvent = 'action';

export const QuizActionType = {
    START: 'start',
    RESTART: 'restart',
    ANSWER: 'answer',
    NEXT: 'next',
    SHARE: 'share'
};
